<script lang="ts" setup>
import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

const { params = {} } = defineProps<{ params?: { message?: MaybeRefOrGetter<string> } }>();

const message = computed((): string => toValue(params.message) ?? '');
</script>
<template>
    <div class="ag-overlay-loading-center">
        <LoadingSpinner
            style="width: 100%; height: 100%"
            size="xxlarge"
            :loading-message="message"
        />
    </div>
</template>
